import React, { useMemo } from 'react';
import styles from './CustomEvents.module.scss';
import cx from 'classnames';
import Spinner from 'common/components/Spinner';
import { capitalizeString } from 'engage/utils/stringHelper';
import { useTranslation } from 'react-i18next';

export const CustomEvent = ({ event }) => {
    return <div data-videoId={`${event.story.id}`} className={cx(styles.event, { [styles.pulse]: event?.new, [styles.loading]: event?.loading })}>
        {event?.loading && <Spinner width={'16px'} height={'16px'} minWidth={'16px'} ninHeight={'16px'} size={'1px'} />}
        {event.story.name}
    </div>
}

export const CustomDayEvent = ({ event }) => {
    return <div data-videoId={`${event.story.id}`}>
        {event.story.name}
    </div>
}

export const CustomAgendaEvent = ({ event }) => {
    return <div aria-event-id={event.id}
        className={cx(styles.agendaEvent)}>
        {event.story.name}
    </div>
}

export const CustomAgendaTime = ({ event, day, label }) => {
    const { t } = useTranslation();
    const isAllDay = label.toLowerCase() == t('schedule.calendar.agenda_all_day').toLowerCase();
    const { isLastDay = false, dayFromDays = null } = useMemo(() => {
        let isLastDay = false;
        let dayFromDays = null;
        const startDate = new Date(event.start);
        const endDate = new Date(event.end);
        const currentDate = new Date(day);
        const multiplyDays = endDate.getTime() - startDate.getTime() / (1000 * 60 * 60 * 24) > 1;
        if (multiplyDays && currentDate >= startDate && currentDate <= endDate) {
            isLastDay = new Date(event.end).getDate() == new Date(day).getDate() && new Date(event.end).getMonth() == new Date(event.start).getMonth();
            const totalDays = Math.ceil((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24));
            let currentDay = Math.ceil((currentDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24));
            dayFromDays = `${currentDay}/${totalDays}`
        }
        return { isLastDay, dayFromDays }
    }, [event, day])

    return <div>
        {isLastDay && <span>{t('schedule.calendar.agenda_until')} </span>}
        <span>{isAllDay ? label : label.toLowerCase()}</span>
        {dayFromDays && <span className={styles.daysLabel}> ({capitalizeString(t('general.day'))} {dayFromDays})</span>}
    </div >
}